export default {
    normal: { url: "line_width/line_width_normal", name: "normal" },
    thick: { url: "line_width/line_width_thick", name: "thick" },
}
